<template>
  <div class="equipPlan">
    <div class="next-time">
      <div  class="flex_1">
        <div class="label">{{ $t("Last Service Date") }}</div>
        <div class="value">{{ planList.last_maintenance_date }}</div>
      </div>
      <div  class="flex_1">
        <div class="label">{{ $t("Last Service Level") }}</div>
        <div class="value">
          {{ (!planList.last_maintenance_item || planList.last_maintenance_item == '-') ? '-' : [
          $t('overview_dynamic.service_type_dict["一级保养"]'),
          $t('overview_dynamic.service_type_dict["二级保养"]'),
          $t('overview_dynamic.service_type_dict["返厂大修"]'),
        ][
        Number(
            planList.last_maintenance_item
        ) - 1
            ]}}
        </div>
      </div>
    </div>
    <div class="warning-time flex_1">
      <div class="label">{{ $t('保养内容') }}</div>
      <div class="warn-main" v-if="planList&&planList.last_maintain_item_data">
        <div
            v-for="(warning, i) in planList.last_maintain_item_data"
            :key="i"
            class="warn-list"
        >
          <div class="list-value">
            <div class="warn-name  d-flex align-items-center">{{ $t(warning)||'-' }}
            </div>
          </div>
        </div>
      </div>
      <div class="warn-main" v-else>
        <div class="warn-list">
            <div class="list-value">
              <div class="warn-name">-</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  props: {
    planList: {
      type: Object,
      default: () => {
        return {
          last_maintenance_date:'',
          last_maintenance_item:'',
          last_maintain_item_data:[],
          next_maintenance_date:'',
          next_maintenance_item:'',
          maintain_item_data:[],
        };
      },
    },
    equip_data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      backColor: {
        normal: "#7CFFB2",
        warning: "#F8C533",
        error: "#FF706F",
      },
    };
  },
  computed: {

  },
  watch:{

  },
  methods: {
    speedNumber(s_time) {
      if (s_time >= 70) {
        return "normal";
      }
      if (s_time < 70 && s_time >= 30) {
        return "warning";
      }
      if (s_time < 30) {
        return "error";
      }
    },

  },
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.equipPlan {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;

  .next-time {
    display: flex;
    margin-top: 10px;
    .label {
      margin-bottom: 5px;
    }
    .value {
      font-size: 16px;
      line-height: 24px;
      color: #00e7ff;
    }
  }
  .warning-time {
    display: flex;
    flex-flow: column;
    flex: 1;
    margin-top: 10px;
    overflow: hidden;
    .label {
      margin-bottom: 5px;
    }
    .warn-main {
      overflow: auto;
      .warn-list {
        margin-bottom: 10px;
        padding-right: 10px;
        .list-value {
          display: flex;
          align-items: center;
          .warn-icon {
            margin-right: 5px;
          }
          .warn-name {
            flex: 1;
            color: #00e7ff;
          }
          .warn-original{
            width:80px;
            height:20px;
            line-height: 20px;
            border-top-right-radius: 25px;
            border-bottom-right-radius: 25px;
            font-size: 12px;
            background: rgb(36, 177, 156);
            text-align: center;
            margin-left: 20px;
          }
        }
      }
    }
  }
}
/* 隐藏滚动条*/ 
.warn-main::-webkit-scrollbar {
  display: none; /* Chrome Safari */

}
.warn-main{
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}

/* 加上 -webkit- 注意兼容 */
.ant-css {
  background: -webkit-linear-gradient(135deg,
      #ffffff,
      #ffffff 25%,
      #ffffff 50%,
      #CD9F32 55%,
      #ffffff 65%,
      #ffffff 80%,
      #ffffff 95%,
      #ffffff);
  /* 文字颜色填充设置为透明 */
  -webkit-text-fill-color: transparent;
  /* 背景裁剪，即让文字使用背景色 */
  -webkit-background-clip: text;
  /* 背景图放大一下，看着柔和一些 */
  -webkit-background-size: 200% 100%;
  /* 应用动画flowCss 12秒速度 无限循环 线性匀速动画*/
  -webkit-animation: flowCss 12s infinite linear;
}

@keyframes flowCss {
  0% {
    /* 移动背景位置 */
    background-position: 0 0;
  }

  100% {
    background-position: -400% 0;
  }
}

.ant-css:hover {
  -webkit-animation: flowCss 4s infinite linear;
}
</style>
